import { USER_INPUT_PREVIEW_SIGNATURE_SUCCESS } from "../../../../Constant/ApaManagement/ApaPreparationByUser/Signature/UserInputPreviewSignatureConstant";


export const getUserInputPreviewSignatureReducer = (state = { userinputsignature: {} }, action) => {

    switch (action.type) {
        case USER_INPUT_PREVIEW_SIGNATURE_SUCCESS:
            return {
                ...state,
                loading: false,
                userinputsignature: action.payload


            }

        default:
            return state
    }


};